export const pathLocale = '/sg/en';
